<template>
    <div class="flex items-center justify-center flex-col text-center">
      <div>
        <h1 class="text-6xl font-bold mb-6">Seite im Aufbau</h1>
        <p class="text-xl text-gray-800 mb-4">
          Diese Website wird aktuell aufgebaut und steht bald zur Verfügung.
        </p>
        <p class="text-md text-gray-700">
          Wir arbeiten gerade im Hintergrund daran, alles für dich bereitzustellen. Bitte schaue später wieder vorbei.
        </p>
      </div>
    </div>
</template>

<script setup lang="ts">
</script>